import { render } from "./ReferralTable.vue?vue&type=template&id=48fcb0b6&scoped=true"
import script from "./ReferralTable.vue?vue&type=script&lang=js"
export * from "./ReferralTable.vue?vue&type=script&lang=js"

import "./ReferralTable.vue?vue&type=style&index=0&id=48fcb0b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fcb0b6"]])

export default __exports__